<template>
  <div>
    <br />
    <h4 class="font-weight-bold text-primary text-left">New User Promo</h4>
    <br />
    <br />
    <b-card>
      <h4 class="font-weight-bold text-primary text-left">Edit</h4>
      <br />
      <b-row align="left">
        <b-col>
          <b-card class="text-center bg-gray-100">
            <b-row>
              <b-col>
                <img v-show="!file" v-if="items.image" width="100%" :src="items.image" />
                <img v-show="file" v-if="url" width="100%" :src="url" />
              </b-col>
            </b-row>
            <input
              type="file"
              ref="file"
              style="display: none"
              name="image"
              v-validate="'image|minimalDimensions:720,500|size:2000|ext:jpg,png,gif,jpeg'"
              @change="onChangeFileUpload()"
            />
            <br />
            <b-link
              @click="$refs.file.click()"
              v-show="!file && !items.image"
              variant="primary"
              class="text-primary btn"
            >
              <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
              <label class="text-danger">*</label>
            </b-link>
            <b-button
              @click="$refs.file.click()"
              v-show="file || items.image"
              variant="outline-primary"
              class
            >
              <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
            </b-button>
            <br />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('image') }}</p>
            <p
              class="text-gray-500"
            >Attach an image (the file must be at least 720x500 pixels and maximum 2MB. Image must be in JPEG, PNG, or GIF format)</p>
          </b-card>
          <br />
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col md="8">
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Title Bahasa"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'required'"
                  name="title_id"
                  data-vv-as="Title Bahasa"
                  v-model="items.title.id"
                  placeholder="Title Bahasa"
                />
                <b-form-invalid-feedback
                  id="input-title_id-feedback"
                >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Title English"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'required'"
                  name="title_en"
                  data-vv-as="Title English"
                  v-model="items.title.en"
                  placeholder="Title English"
                />
                <b-form-invalid-feedback
                  id="input-title_en-feedback"
                >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Content Bahasa"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="items.content.id"
                  tag-name="textarea"
                  placeholder="Content Bahasa"
                  v-validate="'required'"
                  name="content_id"
                  data-vv-as="Content English"
                  class="form-control"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('content_id') }}</p>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Content English"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="items.content.en"
                  tag-name="textarea"
                  placeholder="Content English"
                  v-validate="'required'"
                  name="content_en"
                  data-vv-as="Content English"
                  class="form-control"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('content_en') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label-class="control-label"
                label="Promo Code"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'alpha_num'"
                  name="promo_code"
                  data-vv-as="Promo Code"
                  v-model="items.promo_code"
                  placeholder="Promo Code"
                />
                <b-form-invalid-feedback
                  id="input-promo_code-feedback"
                >{{ veeErrors.first('promo_code') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Product"
                label-for="input-1"
              >
                <vue-multiselect
                  @focus="getDetailProduct(items.product_master.id)"
                  id="ajax"
                  open-direction="bottom"
                  v-model="items.product_master"
                  v-validate="'required'"
                  data-vv-as="Product"
                  name="product"
                  :preserve-search="true"
                  :options="productList"
                  placeholder="Type to search Product"
                  track-by="id"
                  label="name"
                  class="text-capitalize"
                  :loading="isLoadingProduct"
                  :searchable="true"
                  @search-change="asyncFindProduct"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <b-row>
                      <b-col md="3">{{option.code}}</b-col>
                      <b-col class="font-weight-bold" md="5">{{ option.name }}</b-col>
                      <b-col class="text-gray-400" md="4">Rp. {{option.normal_price}}</b-col>
                    </b-row>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">
                        <b-row>
                          <b-col md="3">{{props.option.code}}</b-col>
                          <b-col class="font-weight-bold" md="5">{{ props.option.name }}</b-col>
                          <b-col class="text-gray-400" md="4">Rp. {{props.option.normal_price}}</b-col>
                        </b-row>
                      </span>
                    </div>
                  </template>
                </vue-multiselect>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('product') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Dicount Type"
                label-for="input-1"
              >
                <vue-multiselect
                  v-model="items.discount_type"
                  deselect-label="Can't remove this value"
                  track-by="id"
                  label="name"
                  v-validate="'required'"
                  name="discount_type"
                  data-vv-as="Discount Type"
                  placeholder="Select one"
                  :options="discount_typeList"
                  :searchable="false"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.name }}</strong>
                  </template>
                </vue-multiselect>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('discount_type') }}</p>
              </b-form-group>
            </b-col>
            <b-col v-show="items.discount_type.id == ''"></b-col>
            <b-col v-show="items.discount_type.id == 'amount'">
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Dicount Amount"
                label-for="input-1"
              >
                <b-input-group>
                  <template v-slot:prepend>
                    <b-input-group-text>Rp.</b-input-group-text>
                  </template>
                  <input
                    type="text"
                    v-model="items.discount_value"
                    v-validate="'required|numeric'"
                    name="amount"
                    data-vv-as="Amount"
                    tag-name="textarea"
                    placeholder="Enter amount here"
                    class="form-control"
                  />
                </b-input-group>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('amount') }}</p>
              </b-form-group>
            </b-col>
            <b-col v-show="items.discount_type.id == 'percentage'">
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Dicount Persentage"
                label-for="input-1"
              >
                <b-row>
                  <b-button size="sm" @click="min_percentage" pill>
                    <i class="fas fa-minus"></i>
                  </b-button>
                  <b-col md="4">
                    <input
                      v-model="items.discount_value"
                      v-validate="items.discount_type.id == 'percentage'?'required|numeric|max_value:100|min_value:1':'required|numeric|min_value:1'"
                      name="percentage"
                      data-vv-as="Percentage"
                      type="text"
                      class="form-control"
                      placeholder="Length"
                    />
                  </b-col>
                  <b-button size="sm" @click="plus_percentage" pill>
                    <i class="fas fa-plus"></i>
                  </b-button>
                </b-row>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('percentage') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Quantity Product/user"
                label-for="input-1"
              >
                <b-row>
                  <b-col md="2">
                    <b-button size="sm" @click="min" pill>
                      <i class="fas fa-minus"></i>
                    </b-button>
                  </b-col>
                  <b-col md="6">
                    <b-form-input
                      v-model="items.qty_product_per_promo"
                      type="number"
                      v-validate="'required|numeric|min_value:1'"
                      name="quantity"
                      data-vv-as="Quantity"
                      readonly="readonly"
                      placeholder="Length"
                    ></b-form-input>
                  </b-col>
                  <b-col md="2">
                    <b-button size="sm" @click="plus" pill>
                      <i class="fas fa-plus"></i>
                    </b-button>
                  </b-col>
                </b-row>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('quantity') }}</p>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Quota Promo/user">
                <b-row>
                  <b-col md="4" class="text-left" align="left">
                    <b-row>
                      <b-col md="2">
                        <b-button size="sm" @click="min_limit" pill>
                          <i class="fas fa-minus"></i>
                        </b-button>
                      </b-col>
                      <b-col md="6">
                        <b-form-input
                          v-model="items.quota_promo_per_user"
                          v-validate="'required|numeric|min_value:1'"
                          name="limit"
                          data-vv-as="Limit"
                          readonly="readonly"
                          type="number"
                          placeholder="Length"
                        ></b-form-input>
                      </b-col>
                      <b-col md="2">
                        <b-button size="sm" @click="plus_limit" pill>
                          <i class="fas fa-plus"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('limit') }}</p>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Product Dimension"
                label-for="input-1"
              >
                <b-row>
                  <b-col>
                    <b-form-group
                      id="input-group-1"
                      class="required"
                      label-class="control-label"
                      label="Length"
                      label-for="input-1"
                    >
                      <input
                        id="input-1"
                        type="number"
                        class="form-control"
                        disabled
                        :value="items.product_master ? detail_product.dimension_length:''"
                        placeholder="Length"
                      />
                      <b-form-invalid-feedback
                        id="input-length-feedback"
                      >{{ veeErrors.first('length') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="input-group-1"
                      class="required"
                      label-class="control-label"
                      label="Width"
                      label-for="input-1"
                    >
                      <input
                        id="input-1"
                        type="number"
                        class="form-control"
                        disabled
                        :value="items.product_master ? detail_product.dimension_width:''"
                        placeholder="Width"
                      />
                      <b-form-invalid-feedback
                        id="input-width-feedback"
                      >{{ veeErrors.first('width') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="input-group-1"
                      class="required|numeric"
                      label-class="control-label"
                      label="Height"
                      label-for="input-1"
                    >
                      <input
                        id="input-1"
                        type="number"
                        class="form-control"
                        disabled
                        :value="items.product_master ? detail_product.dimension_height:''"
                        placeholder="Height"
                      />
                      <b-form-invalid-feedback
                        id="input-height-feedback"
                      >{{ veeErrors.first('height') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="input-group-1" label-for="input-1">
                <label>
                  Item(s) Fit to
                  <b-spinner v-show="loadingFitTo" small label="Spinning"></b-spinner>
                </label>
                <b-row class="ml-3">
                  <b-col>Small (S)</b-col>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.small_minimum:''"
                      placeholder="Min"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">to</p>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.small_maximum:''"
                      placeholder="Max"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">Item</p>
                </b-row>
                <b-row class="ml-3 mt-3">
                  <b-col>Medium (M)</b-col>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.medium_minimum:''"
                      placeholder="Min"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">to</p>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.medium_maximum:''"
                      placeholder="Max"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">Item</p>
                </b-row>
                <b-row class="ml-3 mt-3">
                  <b-col>Large (L)</b-col>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.large_minimum:''"
                      placeholder="Min"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">to</p>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.large_maximum:''"
                      placeholder="Max"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">Item</p>
                </b-row>
                <b-row class="ml-3 mt-3">
                  <b-col>Custom (C)</b-col>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.custom_minimum:''"
                      placeholder="Min"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">to</p>
                  <b-col>
                    <b-form-input
                      type="number"
                      readonly="readonly"
                      :value="items.product_master ? detail_product.fit_to.custom_maximum:''"
                      placeholder="Max"
                    ></b-form-input>
                  </b-col>
                  <p class="pt-2 mb-0">Item</p>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Name"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  :value="items.product_master ? detail_product.sender_name:''"
                  type="text"
                  disabled
                  name="name"
                  data-vv-as="Name"
                  placeholder="Enter Name"
                  class="form-control"
                />
                <b-form-invalid-feedback id="input-name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Contact"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  disabled
                  :value="items.product_master ? detail_product.sender_phone_number:''"
                  type="text"
                  name="contact"
                  data-vv-as="Contact"
                  class="form-control"
                  placeholder="Enter Contact"
                />
                <b-form-invalid-feedback
                  id="input-contact-feedback"
                >{{ veeErrors.first('contact') }}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                v-show="items.product_master.type == 'pre_order'"
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Destination Location"
                label-for="input-1"
              >
                <gmap-autocomplete
                  disabled
                  :value="items.product_master ? detail_product.pre_order.pickup_address:''"
                  class="form-control"
                  @place_changed="setPlace"
                ></gmap-autocomplete>

                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('destination') }}</p>
              </b-form-group>
              <div v-show="items.product_master.type == 'pre_order'">
                <gmap-map
                  :center="items.product_master ? detail_product.pre_order.pickup_location:center"
                  :zoom="12"
                  style="width:100%;  height: 400px;"
                >
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    @click="center=m.position"
                  ></gmap-marker>
                </gmap-map>
              </div>
              <b-row v-show="items.product_master.type == 'pre_order'">
                <b-col>
                  <b-form-group id="input-group-1" label="Latitude" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      :value="items.product_master ? detail_product.pre_order.pickup_location.latitude:''"
                      type="number"
                      readonly="readonly"
                      placeholder="0"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-group-1" label="Longitude" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      :value="items.product_master ? detail_product.pre_order.pickup_location.longitude:''"
                      type="number"
                      readonly="readonly"
                      required
                      placeholder="0"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-show="items.product_master.type == 'stock_point'">
            <b-col>
              <b-form-group id="fieldset-1" label-class="mb-0" label-for="input-1">PH & Stock</b-form-group>
              <div
                class="form-group"
                v-for="(input , k) in items.product_master ? detail_product.stock_point:ph_and_stock"
                :key="k"
              >
                <b-row>
                  <b-col md="3"></b-col>
                  <b-col md="3" class="text-right"></b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <vue-multiselect
                      :value="items.product_master ? input.warehouse:''"
                      tag-placeholder="Add this as new tag"
                      placeholder="Search or add a Paxel House"
                      label="name"
                      track-by="code"
                      disabled
                      :options="ph"
                    ></vue-multiselect>
                  </b-col>
                  <b-col>
                    <input
                      id="input-1"
                      type="number"
                      class="form-control"
                      :value="items.product_master ? input.stock:''"
                      disabled
                      placeholder="Stock PH"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3" class="mt-4">
                    <!-- <b-button
                      block
                      variant="outline-primary"
                      @click="add(k)"
                      v-show="k == ph_and_stock.length-1"
                    >
                      <i class="fas fa-plus"></i> Add More
                    </b-button>-->
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="text-center" v-if="newuser_availability != null">
              <div class="text-success" style="width:100%;margin-top:.25rem;font-size: 80%;">
                <label>{{newuser_availability.message}}</label>
                <label v-for="message in newuser_availability.data" :key="message">{{message}}</label>
              </div>
            </b-col>
            <b-col class="text-center" v-else-if="error_availability != null">
              <div class="text-danger" style="width:100%;margin-top:.25rem;font-size: 80%;">
                <label>{{error_availability.message}}</label>
                <label v-for="message in error_availability.data" :key="message">{{message}}</label>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      @input="getNewUserAvailability()"
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="items.publish_date_start"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetStardate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      @input="getNewUserAvailability()"
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="items.publish_date_end"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetEnddate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
          </b-row>
          <br />

          <br />
          <b-row align="right">
            <b-col>
              <b-button
                size="lg"
                variant="primary"
                @click="put()"
                :disabled="loading || error_availability != null"
                class="mr-5"
              >Save</b-button>
              <b-button
                variant="warning"
                @click="modalShow = !modalShow"
                :disabled="!file && !items.image"
                class="mr-5"
                size="lg"
              >Preview</b-button>
              <router-link :to="{name: 'newUserPromo'}">
                <b-button size="lg" variant="outline-secondary">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalShow" hide-footer hide-header title="Preview Image">
      <b-row>
        <b-col>
          <h5 class="font-weight-bold text-dark">Preview</h5>
        </b-col>
      </b-row>
      <br />
      <b-card
        v-show="file"
        overlay
        :img-src="url"
        img-alt="Card Image"
        style="max-width: 100%;"
        v-if="url"
        text-variant="white"
      >
        <b-card-text>
          <h1 style="margin-top:35%;">{{items.title.id}}</h1>
          <h6 v-html="items.content.id"></h6>
        </b-card-text>
      </b-card>
      <b-card
        v-show="!file"
        v-if="items.image"
        overlay
        :img-src="items.image"
        img-alt="Card Image"
        style="max-width: 100%;"
        text-variant="white"
      >
        <b-card-text>
          <h1 style="margin-top:35%;">{{items.title.id}}</h1>
          <h6 v-html="items.content.id"></h6>
        </b-card-text>
      </b-card>
      <br />
      <b-row>
        <b-col align="right">
          <b-button class="py-1 px-4" @click="modalShow=false" variant="outline-primary">OK</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      center: { lat: -6.2, lng: 106.816666 },
      markers: [],
      places: [],
      currentPlace: null,
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      modalShow: false,
      is_unlimited: null,
      quantity: 1,
      file: "",
      url: "",
      sender_name: "",
      phone_number: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      period_start: "",
      period_end: "",
      is_always_active: false,
      is_promo_roles_yes: false,
      small_from: "",
      small_to: "",
      medium_from: "",
      medium_to: "",
      large_from: "",
      large_to: "",
      extrapackaging: null,
      ph: [],
      ph_and_stock: [
        {
          warehouse: null,
          stock: null
        }
      ],
      detail_product: [],
      addon: null,
      dimension: null,
      is_fragile: false,
      is_highlight: false,
      counthighlight: null,
      promo_code: null,
      note: "",
      sumprint: 0,
      percentage: 1,
      limit: 1,
      amount: 1,
      items: [],
      dataPackaging: [],
      dataPh: [],
      dataItem: [],
      dataAddon: [],
      product: "",
      productList: [],
      isLoadingProduct: false,
      searchTermProduct: "",
      discount_type: "",
      discount_typeList: [],
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      newuser_availability: null,
      error_availability: null
    };
  },
  beforeCreate() {
    this.$store
      .dispatch("NewUserPromoModule/getNewUserPromo", this.$route.params.id)
      .then(response => {
        this.items = response.data.data;
        this.$store.dispatch(
          "PaxelMarketModule/getProductMasterId",
          response.data.data.product_master.id
        );
        const formData = new FormData();
        formData.append("period_start", response.data.data.publish_date_start);
        formData.append("period_end", response.data.data.publish_date_end);
        formData.append("new_user_promo_id", this.$route.params.id);
        this.$store
          .dispatch("NewUserPromoModule/getNewUserAvailabilityEdit", formData)
          .then(response => {
            this.newuser_availability = response.data;
          })
          .catch(error => {
            this.error_availability = error.response.data;
          });
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error,
          showConfirmButton: false,
          timer: 1500
        });
      });

    this.$store.dispatch("NewUserPromoModule/getDiscountType");
  },
  created() {
    this.$store.watch(
      state => state.PaxelMarketModule.product_master_id,
      (newValue, oldValue) => {
        this.detail_product = newValue;
      }
    );
    this.$store.watch(
      state => state.NewUserPromoModule.dicountType,
      (newValue, oldValue) => {
        this.discount_typeList = newValue;
      }
    );
  },
  methods: {
    getDetailProduct(payload) {
      this.$store.dispatch("PaxelMarketModule/getProductMasterId", payload);
    },
    asyncFindProduct(query) {
      this.isLoadingProduct = true;
      this.searchTermProduct = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function() {
      const product = this.searchTermProduct.toLowerCase();
      const formData = new FormData();
      formData.append("search_param", product);
      formData.append("limit", 10);
      formData.append("page", 1);
      formData.append("status", "publish");
      formData.append("product_status", "new_user_promo");
      this.$store
        .dispatch("PaxelMarketModule/getProductMaster", formData)
        .then(response => {
          this.productList = response.data.data.results;
          this.isLoadingProduct = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.isLoadingProduct = false;
        });
    }, 1000),
    // get() {
    //   if (this.addon) {
    //     this.$store
    //       .dispatch("NewUserPromoModule/getDimension", this.addon.code)
    //       .then(response => {
    //         console.log(response);
    //         this.fit_to();
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    //   }
    // },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getNewUserAvailability() {
      const formData = new FormData();
      if (
        this.items.publish_date_start == "" &&
        this.items.publish_date_end != ""
      ) {
        const endDate = moment(this.items.publish_date_end).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", this.items.publish_date_start);
        formData.append("period_end", endDate);
      }
      if (
        this.items.publish_date_start != "" &&
        this.items.publish_date_end == ""
      ) {
        const startDate = moment(this.items.publish_date_start).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", startDate);
        formData.append("period_end", this.items.publish_date_end);
      }
      if (
        this.items.publish_date_start != "" &&
        this.items.publish_date_end != ""
      ) {
        const startDate = moment(this.items.publish_date_start).format(
          "YYYY-MM-DD"
        );
        const endDate = moment(this.items.publish_date_end).format(
          "YYYY-MM-DD"
        );

        formData.append("period_start", startDate);
        formData.append("period_end", endDate);
      }
      if (
        this.items.publish_date_start == "" &&
        this.items.publish_date_end == ""
      ) {
        formData.append("period_start", this.items.publish_date_start);
        formData.append("period_end", this.items.publish_date_end);
      }
      formData.append("new_user_promo_id", this.$route.params.id);
      this.$store
        .dispatch("NewUserPromoModule/getNewUserAvailabilityEdit", formData)
        .then(response => {
          this.newuser_availability = response.data;
          this.error_availability = null;
        })
        .catch(error => {
          this.newuser_availability = null;
          this.error_availability = error.response.data;
        });
    },
    resetStardate() {
      const formData = new FormData();
      if (
        this.items.publish_date_start == "" &&
        this.items.publish_date_end != ""
      ) {
        const endDate = moment(this.items.publish_date_end).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", this.items.publish_date_start);
        formData.append("period_end", endDate);
      }
      if (
        this.items.publish_date_start != "" &&
        this.items.publish_date_end == ""
      ) {
        const startDate = moment(this.items.publish_date_start).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", startDate);
        formData.append("period_end", this.items.publish_date_end);
      }
      if (
        this.items.publish_date_start != "" &&
        this.items.publish_date_end != ""
      ) {
        const startDate = moment(this.items.publish_date_start).format(
          "YYYY-MM-DD"
        );
        const endDate = moment(this.items.publish_date_end).format(
          "YYYY-MM-DD"
        );

        formData.append("period_start", startDate);
        formData.append("period_end", endDate);
      }
      if (
        this.items.publish_date_start == "" &&
        this.items.publish_date_end == ""
      ) {
        formData.append("period_start", this.items.publish_date_start);
        formData.append("period_end", this.items.publish_date_end);
      }
      formData.append("new_user_promo_id", this.$route.params.id);
      this.$store
        .dispatch("NewUserPromoModule/getNewUserAvailabilityEdit", formData)
        .then(response => {
          this.newuser_availability = response.data;
          this.error_availability = null;
        })
        .catch(error => {
          this.newuser_availability = null;
          this.error_availability = error.response.data;
        });
      this.items.publish_date_start = "";
    },
    resetEnddate() {
      const formData = new FormData();
      if (
        this.items.publish_date_start == "" &&
        this.items.publish_date_end != ""
      ) {
        const endDate = moment(this.items.publish_date_end).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", this.items.publish_date_start);
        formData.append("period_end", endDate);
      }
      if (
        this.items.publish_date_start != "" &&
        this.items.publish_date_end == ""
      ) {
        const startDate = moment(this.items.publish_date_start).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", startDate);
        formData.append("period_end", this.items.publish_date_end);
      }
      if (
        this.items.publish_date_start != "" &&
        this.items.publish_date_end != ""
      ) {
        const startDate = moment(this.items.publish_date_start).format(
          "YYYY-MM-DD"
        );
        const endDate = moment(this.items.publish_date_end).format(
          "YYYY-MM-DD"
        );

        formData.append("period_start", startDate);
        formData.append("period_end", endDate);
      }
      if (
        this.items.publish_date_start == "" &&
        this.items.publish_date_end == ""
      ) {
        formData.append("period_start", this.items.publish_date_start);
        formData.append("period_end", this.items.publish_date_end);
      }
      formData.append("new_user_promo_id", this.$route.params.id);
      this.$store
        .dispatch("NewUserPromoModule/getNewUserAvailabilityEdit", formData)
        .then(response => {
          this.newuser_availability = response.data;
          this.error_availability = null;
        })
        .catch(error => {
          this.newuser_availability = null;
          this.error_availability = error.response.data;
        });
      this.items.publish_date_end = "";
    },
    // fit_to() {
    //   if (this.dimension) {
    //     var dimension =
    //       parseInt(this.dimension.length) *
    //       parseInt(this.dimension.width) *
    //       parseInt(this.dimension.height);
    //     var small = 1540;
    //     var medium = 7200;
    //     var large = 21080;

    //     var max_small = dimension > 0 ? Math.floor(small / dimension) : 0;
    //     var min_small = max_small >= 1 ? 1 : 0;
    //     var max_medium = dimension > 0 ? Math.floor(medium / dimension) : 0;
    //     var min_medium =
    //       max_medium >= 1 && max_small + 1 >= 1 ? max_small + 1 : 0;
    //     var max_large = dimension > 0 ? Math.floor(large / dimension) : 0;
    //     var min_large =
    //       max_large >= 1 && max_medium + 1 >= 1 ? max_medium + 1 : 0;

    //     this.small_from = min_small;
    //     this.small_to = max_small;
    //     this.medium_from = min_medium;
    //     this.medium_to = max_medium;
    //     this.large_from = min_large;
    //     this.large_to = max_large;
    //   }
    // },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    min() {
      if (this.items.qty_product_per_promo == 1) {
        this.items.qty_product_per_promo == 1;
      } else {
        this.items.qty_product_per_promo -= 1;
      }
    },
    plus() {
      this.items.qty_product_per_promo++;
    },
    min_percentage() {
      if (this.items.discount_value == 1) {
        this.items.discount_value == 1;
      } else {
        this.items.discount_value -= 1;
      }
    },
    plus_percentage() {
      if (this.items.discount_value == 100) {
        this.items.discount_value == 100;
      } else {
        this.items.discount_value++;
      }
    },
    min_limit() {
      if (this.items.quota_promo_per_user == 1) {
        this.items.quota_promo_per_user == 1;
      } else {
        this.items.quota_promo_per_user -= 1;
      }
    },
    plus_limit() {
      if (this.items.quota_promo_per_user == 100) {
        this.items.quota_promo_per_user == 100;
      } else {
        this.items.quota_promo_per_user++;
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10800000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this New User Promo!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              const formData = new FormData();
              formData.append("promo_code", this.items.promo_code);
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("content_id", this.items.content.id);
              formData.append("content_en", this.items.content.en);

              formData.append("image", this.file);
              formData.append(
                "product_master_id",
                this.items.product_master.id
              );
              formData.append("discount_type", this.items.discount_type.id);
              formData.append("discount_value", this.items.discount_value);
              formData.append(
                "qty_product_per_promo",
                this.items.qty_product_per_promo
              );
              formData.append(
                "quota_promo_per_user",
                this.items.quota_promo_per_user
              );
              if (
                this.items.publish_date_start == "" &&
                this.items.publish_date_end != ""
              ) {
                const endDate = moment(this.items.publish_date_end).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", this.items.publish_date_start);
                formData.append("period_end", endDate);
              }
              if (
                this.items.publish_date_start != "" &&
                this.items.publish_date_end == ""
              ) {
                const startDate = moment(this.items.publish_date_start).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", startDate);
                formData.append("period_end", this.items.publish_date_end);
              }
              if (
                this.items.publish_date_start != "" &&
                this.items.publish_date_end != ""
              ) {
                const startDate = moment(this.items.publish_date_start).format(
                  "YYYY-MM-DD"
                );
                const endDate = moment(this.items.publish_date_end).format(
                  "YYYY-MM-DD"
                );

                formData.append("period_start", startDate);
                formData.append("period_end", endDate);
              }
              if (
                this.items.publish_date_start == "" &&
                this.items.publish_date_end == ""
              ) {
                formData.append("period_start", this.items.publish_date_start);
                formData.append("period_end", this.items.publish_date_end);
              }

              this.loading = true;
              this.$store
                .dispatch("NewUserPromoModule/putNewUserPromo", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "newUserPromo" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    },
    setPlace(place) {
      this.currentPlace = place;
      this.detail_product.pre_order.pickup_location.latitude = place.geometry.location.lat();
      this.detail_product.pre_order.pickup_location.longitude = place.geometry.location.lng();
      this.detail_product.pre_order.pickup_address = place.formatted_address;
      const marker = {
        lat: this.currentPlace.geometry.location.lat(),
        lng: this.currentPlace.geometry.location.lng()
      };
      this.markers.push({ position: marker });
      this.places.push(this.currentPlace);
      this.center = marker;
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  },
  mounted() {
    this.geolocate();
  },
  beforeUpdate() {
    const marker = {
      lat: this.detail_product.pre_order.pickup_location.latitude,
      lng: this.detail_product.pre_order.pickup_location.longitude
    };
    this.markers.push({ position: marker });
    this.center = marker;
  }
};
</script>

<style>
</style>
